// extracted by mini-css-extract-plugin
export var container = "GalleryPreview-module--container--28fZM";
export var open = "GalleryPreview-module--open--2l1Yt";
export var preview = "GalleryPreview-module--preview--3NIqU";
export var preview__photo = "GalleryPreview-module--preview__photo--J0_8w";